const awsmobile = {
    "aws_user_pools_web_client_id": "20hhhu6crapc0lbdabatlkuq9n",
};


export default awsmobile;
